import React, { useState } from 'react';
import { Box, Title } from 'affiny-ui/src';

interface ITab {
  isSelected: boolean;
  title: string;
}

export const Tab = ({ isSelected, title }: ITab) => {
  const [onHover, setOnHover] = useState(false);

  return (
    <Box
      cursor="pointer"
      my="xLarge"
      borderBottomWidth={4}
      borderBottomStyle="solid"
      borderBottomColor={isSelected ? 'accent' : 'transparent_white'}
      pb="small"
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <Title color={isSelected ? 'accent' : onHover ? 'primary' : 'secondary'}>
        {title}
      </Title>
    </Box>
  );
};
